import React from 'react';
// Images
import CatTextLogoSvg from '../../assets/images/logos/cat-app-text-svg.svg';
import { Link } from 'react-router-dom';
import { HOME_PAGE_URL } from '../../utils/Routes';

function TextLogoSection() {
  return (
    <section className='absolute top-4 lg:top-6 left-4 lg:left-8'>
      <Link to={HOME_PAGE_URL} aria-label='Home page link' title='Home page'>
        <figure>
          <img
            src={CatTextLogoSvg}
            alt='Cat app text logo'
            className='w-28 lg:w-36'
          />
        </figure>
      </Link>
    </section>
  );
}

export default TextLogoSection;
